import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LanguageIcon from '@mui/icons-material/Language';
import YouTubeIcon from '@mui/icons-material/YouTube';
import Link from 'next/link';

import TelegramIcon from '../shared/icons/telegram-icon';
import Tiktok from '../shared/icons/tiktok';
import Twitch from '../shared/icons/twitch';
import TwitterIcon from '../shared/icons/twitter-icon';

export const getSocialNetworkIcon = (socialNetwork, index) => {
    let icon = '';

    switch (socialNetwork.name) {
        case 'Web':
            icon = <LanguageIcon style={{ color: '#1a892d', fontSize: '18px' }} />;
            break;
        case 'Twitter':
            icon = <TwitterIcon color={'#000'} />;
            break;
        case 'Youtube':
            icon = <YouTubeIcon style={{ color: '#dc4141', fontSize: '18px' }} />;
            break;
        case 'Tik Tok':
            icon = <Tiktok width={18} height={18} />;
            break;
        case 'Instagram':
            icon = <InstagramIcon style={{ color: '#a10c4a', fontSize: '18px' }} />;
            break;
        case 'Twitch':
            icon = (
                <Twitch
                    width={18}
                    height={18}
                    styles={{
                        position: 'relative',
                        top: '1.5px',
                    }}
                />
            );
            break;
        case 'Facebook':
            icon = <FacebookIcon style={{ color: '#1d6fb1', fontSize: '18px' }} />;
            break;
        case 'Telegram':
            icon = <TelegramIcon color={'#000'} />;
            break;
        case 'Telegram-2':
            icon = <TelegramIcon color={'#0284c7'} />;
            break;
        default:
            break;
    }

    return (
        <Link key={index} href={socialNetwork.url} target="_blank" rel="noopener noreferrer" prefetch={false}>
            {icon}
        </Link>
    );
};
